module.exports = __webpack_public_path__ + "static/img/mobiletitle.6ed2070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobiletitle.png
// module id = 0vvW
// module chunks = 1